import { Component } from '@angular/core';
import { NotificationService } from '../../../services/notification/notification.service';
import { CommonModule } from '@angular/common';
import { ToastBodyComponent, ToastComponent, ToasterComponent, ToastHeaderComponent } from '@coreui/angular-pro';

@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [CommonModule, ToastBodyComponent, ToastComponent, ToasterComponent, ToastHeaderComponent],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  constructor(public notificationService: NotificationService) {}
}
